import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Target, Briefcase } from "lucide-react";
import OSLayout from "../../components/os/OSLayout";
import Positions from "./Positions";
import WorkforcePlanning from "./WorkforcePlanning";

export default function WorkforceHub() {
  const [sp] = useSearchParams();
  const [main, setMain] = useState(sp.get("tab") === "puestos" || sp.get("tab") === "headcount" ? "puestos" : "planeacion");
  useEffect(() => {
    const t = sp.get("tab");
    if (t === "puestos" || t === "headcount") setMain("puestos");
    else if (t === "planeacion") setMain("planeacion");
  }, [sp]);

  return (
    <OSLayout title="OMNIA Workforce">
      <div className="space-y-6" data-testid="workforce-hub">
        <p className="text-sm text-navy/55 -mt-2">Planeación de plantilla, puestos, headcount y arquitectura organizacional en un solo lugar.</p>
        <div className="flex gap-2 border-b border-navy/10 pb-2">
          {[["planeacion", "Planeación", Target], ["puestos", "Job Architecture", Briefcase]].map(([k, l, Ic]) => (
            <button
              key={k}
              onClick={() => setMain(k)}
              data-testid={`wfhub-tab-${k}`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm ${main === k ? "bg-violet text-white" : "text-navy/55 hover:bg-navy/5"}`}
            >
              <Ic className="w-4 h-4" /> {l}
            </button>
          ))}
        </div>
        {main === "planeacion" ? <WorkforcePlanning embedded /> : <Positions embedded />}
      </div>
    </OSLayout>
  );
}
